document.addEventListener("DOMContentLoaded", () => {
  var table = document.querySelector("#dimensions-table")
  var data = ["first", "second", "third", "fourth", "fifth"]
  var coloumns = ["height", "width", "length"]

  // Create a count variable to count the placements
  var count = 0
  // use a loop to input the measurements from the object
  try{
    if(beds){
      for (var dim in beds){
        for (var variant in beds[dim]){
          for (var unit in beds[dim][variant]){
             count++
             if(count <= 3){
                 table.querySelector("#"+`${data[0]}`+"_"+`${coloumns[unit]}`).innerText = beds[dim][variant][unit]
             } else if (count <= 6) {
                 table.querySelector("#"+`${data[1]}`+"_"+`${coloumns[unit]}`).innerText = beds[dim][variant][unit]
             }else if (count <= 9) {
                 table.querySelector("#"+`${data[2]}`+"_"+`${coloumns[unit]}`).innerText = beds[dim][variant][unit]
             }
          }
        }
      }
    }
  }
  catch(error){
    try{
      if(footstools){
        for (var dim in footstools){
          for (var variant in footstools[dim]){       
            table.querySelector("#"+`${data[0]}`+"_"+`${coloumns[variant]}`).innerText = footstools[dim][variant]
          }
        }
      }
    }
    catch(error){
      try{
        if(base){
          for (var dim in base){
            for (var variant in base[dim]){
              for (var unit in base[dim][variant]){
                 count++
                 if(count <= 3){
                     table.querySelector("#"+`${data[0]}`+"_"+`${coloumns[unit]}`).innerText = base[dim][variant][unit]
                 } else if (count <= 6) {
                     table.querySelector("#"+`${data[1]}`+"_"+`${coloumns[unit]}`).innerText = base[dim][variant][unit]
                 } else if (count <= 9) {
                     table.querySelector("#"+`${data[2]}`+"_"+`${coloumns[unit]}`).innerText = base[dim][variant][unit]
                 } else if (count <= 12) {
                     table.querySelector("#"+`${data[3]}`+"_"+`${coloumns[unit]}`).innerText = base[dim][variant][unit]
                 } else if (count <= 15) {
                     table.querySelector("#"+`${data[4]}`+"_"+`${coloumns[unit]}`).innerText = base[dim][variant][unit]
                 }
              }
            }
          }
        }
      }
      catch(error){
        console.log("No specific sizes")
      }
    }
  }
});
